// Raporlama dönemi — spec docs/superpowers/specs/2026-09-22-reporting-period-design.md (K1, K8).
// annual = yıllık rapor. qN = yılbaşından N. çeyrek sonuna kadarki KÜMÜLATİF ara dönem
// (3/6/9 aylık; Q4 yıllıkla birleşir). Sıra sabittir: UI segmenti ve kanonik sıralama buradan.
import { z } from "zod";

export const PERIOD_TYPES = ["annual", "q1", "q2", "q3"] as const;
export const PeriodType = z
  .enum(PERIOD_TYPES)
  .describe(
    "Raporlama dönemi türü: annual (yıllık) · q1 · q2 · q3 (yılbaşından N. çeyrek sonuna kümülatif ara dönem).",
  );
export type PeriodType = z.infer<typeof PeriodType>;
export const ALL_PERIODS: PeriodType[] = [...PERIOD_TYPES];

export const PERIOD_LABELS: Record<PeriodType, string> = {
  annual: "Yıllık",
  q1: "1. Çeyrek",
  q2: "2. Çeyrek",
  q3: "3. Çeyrek",
};

// Bölüm/soru "geçerli dönemler" listesi: en az bir, tekrar yok, kanonik sıra.
// Bölümde TAVAN, soruda TERCİH; etkin dönem = kesişim (utils/period.ts effectivePeriods).
export const ApplicablePeriodsSchema = z
  .array(PeriodType)
  .min(1, "En az bir dönem seçilmeli")
  .refine((arr) => new Set(arr).size === arr.length, { message: "Dönem tekrar edemez" })
  .transform((arr) => PERIOD_TYPES.filter((p) => arr.includes(p)))
  .describe(
    'Bu öğenin hangi raporlama dönemlerinde sorulacağı; ["annual","q1","q2","q3"] alt kümesi, en az bir. Bölümde yazılmazsa hepsi; soruda yazılmazsa bölümünkü. Etkin dönem = bölüm ∩ soru. Yalnız yıllık raporda anlamlı konular (mali haklar, kâr dağıtımı, uyum beyanı, bağımsız denetim) ["annual"].',
  );
export type ApplicablePeriods = z.infer<typeof ApplicablePeriodsSchema>;
